export const blobBrowserDownload = (
  blob,
  headers,
  fallbackFileName,
  isTrimGuiSuffix = true,
) => {
  const contentType = headers?.get?.("content-type") || "";
  let fileName = fallbackFileName ?? "Bulk_File_Download";

  if (contentType.includes("zip")) {
    if (!fileName.endsWith(".zip")) {
      fileName = `${fileName}.zip`;
    }
  }

  const typedBlob = new Blob([blob], {
    type: contentType || "application/octet-stream",
  });
  const url = window.URL.createObjectURL(typedBlob);
  const a = document.createElement("a");
  const downloadedFileName = isTrimGuiSuffix
    ? fileName.replace(/_[^_]+(?=\.[^.]+$)/, "")
    : fileName;

  a.href = url;
  a.download = downloadedFileName;
  document.body.appendChild(a);
  a.click();
  a.remove();

  window.URL.revokeObjectURL(url);
};
